<template>
  <el-dialog
    title="消息模板同步提示"
    :visible.sync="dialogVisible"
    :before-close="handleClose"
    append-to-body
  >
    <div class="explain">
      <div class="explain-title">说明：</div>
      <div class="explain-tip">
        <div>1、若提示：公众号行业获取失败，说明公众号是订阅号，请更换为服务号</div>
        <div>2、若提示：行业错误，请设置公众号行业为“IT科技/互联网|电子商务”</div>
        <div>3、若提示：模板添加失败，说明公众号消息模板已达上限，请到公众平台删除对应数量的消息模板</div>
      </div>
    </div>
    <div class="data-list">
      <div v-if="dataList.length > 0">
        <div class="data-item" v-for="(item, index) of dataList" :key="index">
          {{ item }}
        </div>
      </div>
      <div class="data-item" v-else>
        {{ message }}
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import { getPlatformUuidKfc } from '@/utils/auth'
  import authorization from '@/javaApi/kfc/authorization'
  const authorizationModel = new authorization()
  export default {
    name: "SyncTemplate",
    components: {
    },
    props: {},
    created() {},
    data: function () {
      return {
        message: '正在同步......',
        dialogVisible: false, //弹出框
        platformUuid: getPlatformUuidKfc(),
        dataList: [],
        //syncTemplateLink: process.env.VUE_APP_KFC_AUTH_URL +'api/open/template-pub/sync?platformUUID='+getPlatformUuidKfc()
      }
    },
    computed:{
      handleClose:function(){
        this.dialogVisible = false;
      }
    },
    methods: {
      init: function () {
        this.$Message.success('正在同步模板消息')
        this.dialogVisible = true;
        this.getSyncTemplateData()
      },
      getSyncTemplateData(){
        const param = {
          platformUuid: this.platformUuid
        }
        authorizationModel.getSyncTemplateData(param).then(response=>{
          const res = response.data
          if(res.success){
            this.dataList = res.data
          }
        }).catch(error=>{
          if(error != 'token invalid'){
            if(error.indexOf('公众号行业获取失败') > -1 || error.indexOf('公众号行业错误') > -1){
              this.message = error
            } else {
              this.$message.error('系统繁忙请稍后再试!')
            }
          }
        })
      }
    }
  }
</script>

<style scoped>
  .color-666{
    color: #666666;
  }
  .color-222{
    color: #222222;
  }
  .font-weight-bold{
    font-weight: bold;
  }
  .text-right{
    text-align: right;
  }
  .padding-5{
    padding: 5px;
  }
  .padding-tb-10{
    padding: 10px 0
  }
  .margin-top-10{
    margin-top: 10px;
  }
  .normal-font {
    color: #FF4F76;;
    font-size: 14px;
  }
  .explain{
    font-family: Alibaba-PuHuiTi-R;
    font-size: 13px;
    color: #D63036;
    line-height: 20px;
    background: #FFFFFF;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    font-family: Alibaba-PuHuiTi-M;
    margin-bottom: 20px;
  }
  .explain .explain-title{
    min-width: 45px;
  }
  .part-div{
    background: #FAFAFA;
    border-radius: 4px;
  }
  .part-div .img-wrap{
    margin: 20px;
  }
  .part-div .img-left{
    margin: 20px 20px 20px 35px;
  }
  .part-div .img-right{
    margin: 20px 35px 20px 20px;
  }
  .part-div .img-wrap .img-box{
    background: #FFFFFF;
  }
  .part-div .img-wrap .img-box img{
    width: 100%
  }
  .part-div .step-btn{
    background-image: linear-gradient(90deg, #FFBB47 6%, #D63036 89%, #D63036 89%);
    border-radius: 17px;
    color: #FFFFFF;
    font-family: Alibaba-PuHuiTi-R;
    font-size: 16px;
    padding: 3px 15px;
  }
  .part-div .step-tip{
    font-family: Alibaba-PuHuiTi-M;
    font-size: 14px;
    color: #222222;
    padding-top: 20px;
  }
  .part-div .step-tip .sync{
    font-family: Alibaba-PuHuiTi-R;
    font-size: 14px;
    color: #FF4F76;
    padding:5px 15px;
    border:1px solid #FF4F76;
    margin-left: 10px;
    cursor: pointer;
  }
  >>>.v-transfer-dom .v-modal{
    z-index: 0 !important;
  }
  >>>.v-transfer-dom .ivu-message{
    z-index: 9999 !important;
  }
  .data-list{
    height: 250px;
    overflow-y: scroll;
  }
  .data-list .data-item{
    margin-bottom: 15px;
    color: black;
  }
</style>



// WEBPACK FOOTER //
// src/components/kfc/SyncTemplateInfo.vue